var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tinymce"},[_c('editor',{attrs:{"id":"tinymce","init":_vm.init},model:{value:(_vm.tinymceHtml.html),callback:function ($$v) {_vm.$set(_vm.tinymceHtml, "html", $$v)},expression:"tinymceHtml.html"}}),_c('el-button',{attrs:{"type":"primary","size":"small","disabled":_vm.status > 0},on:{"click":_vm.onSubmit}},[_vm._v("提交")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }